




import {Vue, Component} from 'vue-property-decorator'

import Dashboard from '@/components/Dashboard.vue'

@Component({
  components: {
    Dashboard
  }
})
export default class DashboardView extends Vue {

}
